import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import Popper from "@material-ui/core/Popper";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Fade from "@material-ui/core/Fade";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";

const useStyles = makeStyles({
  Root: {
    zIndex: 1,
  },
  Content: ({useWidth, useHeight, current}) => ({
    width: (useWidth && current) && current.clientWidth,
    height: (useHeight && current) && current.clientHeight,
  }),
});

const MPopper = ({children, anchorEl: {current}, onClickAway, useWidth, useHeight, ...otherProps}) => {
  const classes = useStyles({useHeight, useWidth, current});
  return (
  <Popper 
    {...otherProps}
    anchorEl={current}
    className={classes.Root}
    transition
    disablePortal
  >
    {({TransitionProps}) => (
      <Fade {...TransitionProps} timeout={350}>
        <Card className={classes.Content}>
          <ClickAwayListener onClickAway={({target}) => (current && !current.contains(target)) && onClickAway()}>
            <CardContent>
              {children}
            </CardContent>
          </ClickAwayListener>
        </Card>
      </Fade>
    )}
  </Popper>
  );
};

MPopper.propTypes = {
  children: PropTypes.element, //The content of the MPopper
  anchorEl: PropTypes.node, //The DOM node that the MPopper will position itelf off of
  onClickAway: PropTypes.func, //Callback for reacting to clicking away from the MPopper
  useWidth: PropTypes.bool, //If true the MPopper will match the width of the DOM target
  useHeight: PropTypes.bool, //IF true the MPopper will match the height of the DOM target
};

export default MPopper;